export const booleanToHuman = (val: boolean): 'yes' | 'no' => (val ? 'yes' : 'no');
